import { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { authService } from '../services/authService';

export const useAuth = () => {
  const { state, logout } = useApp();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      try {
        // Check if user exists and is active
        const hasUser = state.user && state.user.isActive;
        
        // Check if token is valid
        const hasValidToken = authService.isAuthenticated();
        
        // Check if user data exists in localStorage
        const storedUser = authService.getCurrentUser();
        
        if (hasUser && hasValidToken && storedUser) {
          setIsAuthenticated(true);
        } else {
          // If any check fails, logout and clear state
          if (hasUser || storedUser) {
            logout();
          }
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Auth check error:', error);
        logout();
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [state.user, logout]);

  // Global listener for 410/session-expired events emitted by API calls
  useEffect(() => {
    const handleSessionExpired = () => {
      logout();
      window.location.href = '/vendor-app/login';
    };

    window.addEventListener('session-expired', handleSessionExpired);
    return () => window.removeEventListener('session-expired', handleSessionExpired);
  }, [logout]);

  return {
    isAuthenticated,
    isLoading,
    user: state.user,
    logout
  };
};
